import $ from 'jquery';
import Immutable from 'immutable';
import BasePropertyView from 'BasePropertyView.js';
import _template from 'properties/table/column-main-text.ejs';
import TextUtil from 'util/TextUtil.js';
import util from 'util/Util.js';

// PF-5745
import undoService from 'UndoService';
import textConstants from 'TextConstants';

class MainTextView extends BasePropertyView {

    initialize( opts ) {
        this.options = opts || {};
        this.template = _template;
        this.tagName = 'div';
        this.id = opts.el;
        this.colId = this.model.get('selectedRowId');

        this.selectedColor = 'lightgrey';
        this.unselectedColor = 'transparent';

        this.events = {
            'change input[type=text]'   : 'updateAttributes',
            'blur input[type=text]'   : 'lostFocus',
            'focus input[type=text]'   : 'getFocus',
            'click img'                 : 'updateImgAttributes',
            'change select'             : 'updateAttributes',
            'keydown input[name="maxChars"]': 'validatePositiveNumeric'
        };

        if(this.colId){
            let factorykey=this.model.get('gridData')[this.colId].get('factoryKey');
            util.updateHelpDocumentationLink(factorykey);
        }

        this.model.get('gridData')[this.colId].attributes['alignLeftSelection'] = this.unselectedColor;
        this.model.get('gridData')[this.colId].attributes['alignCenterSelection'] = this.unselectedColor;
        this.model.get('gridData')[this.colId].attributes['alignRightSelection'] = this.unselectedColor;

        switch  (this.model.get('gridData')[this.colId].attributes['align']) {
            case 'left':
                this.model.get('gridData')[this.colId].attributes['alignLeftSelection'] = this.selectedColor;
                break;
            case 'center':
                this.model.get('gridData')[this.colId].attributes['alignCenterSelection'] = this.selectedColor;
                break;
            case 'right':
                this.model.get('gridData')[this.colId].attributes['alignRightSelection'] = this.selectedColor;
                break;
        }


        this.listenTo(this.model, 'change', this.render);
        return this;
    }

    validatePositiveNumeric(ev){
        TextUtil.validatePositiveNumeric(ev);
    }

    updateAttributes(ev) {
        ev.preventDefault();

        const propName = ev.currentTarget.name;
        const colId = this.colId;
        const oldPropVal = this.model.get('gridData')[colId].attributes[propName];
        const propVal  = util.sanitizeHTML(ev.currentTarget.value, true, oldPropVal);
        
        // needs to set to the Column Name for this Column
        this.model.get('gridData')[colId].attributes[propName] = propVal;
        // Update without trigger change
        // this.model.trigger('change');
        this.render();

         // PF-5745
         undoService.add({
            undo: () =>{
                this.model.get('gridData')[colId].attributes[propName] = oldPropVal;
                // Update without trigger change
                // this.model.trigger('change');
                this.render();
            },
            redo:() => {
                this.model.get('gridData')[colId].attributes[propName] = propVal;
                // Update without trigger change
                // this.model.trigger('change');
                this.render();
            }
        },textConstants.UNDO_MOVE);
    }

    updateImgAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const colId = this.colId;
        const oldValue = this.model.get('gridData')[this.colId].attributes['align'];

        var newValue = "left";
        this.model.get('gridData')[this.colId].attributes['alignLeftSelection'] = this.unselectedColor;
        this.model.get('gridData')[this.colId].attributes['alignCenterSelection'] = this.unselectedColor;
        this.model.get('gridData')[this.colId].attributes['alignRightSelection'] = this.unselectedColor;
        
        if (propName === "align-center") {
            newValue = "center";
            this.model.get('gridData')[this.colId].attributes['alignCenterSelection'] = this.selectedColor;
        } else if (propName === "align-right") {
            newValue = "right";
            this.model.get('gridData')[this.colId].attributes['alignRightSelection'] = this.selectedColor;
        }
        else {
            this.model.get('gridData')[this.colId].attributes['alignLeftSelection'] = this.selectedColor;
        }
        this.model.get('gridData')[this.colId].attributes['align'] = newValue;
        // Update without trigger change
        // this.model.trigger('change');
        this.render();

         // PF-5745
         undoService.add({
            undo: () =>{
                this.model.get('gridData')[colId].attributes['alignLeftSelection'] = this.unselectedColor;
                this.model.get('gridData')[colId].attributes['alignCenterSelection'] = this.unselectedColor;
                this.model.get('gridData')[colId].attributes['alignRightSelection'] = this.unselectedColor;

                switch (oldValue) {
                    case "left": {
                        this.model.get('gridData')[colId].attributes['alignLeftSelection'] = this.selectedColor;
                        break;
                    }
                    case "center": {
                        this.model.get('gridData')[colId].attributes['alignCenterSelection'] = this.selectedColor;
                        break;
                    }
                    case "right": {
                        this.model.get('gridData')[colId].attributes['alignRightSelection'] = this.selectedColor;
                        break;
                    }
                }
                this.model.get('gridData')[colId].attributes['align'] = oldValue;
                // Update without trigger change
                // this.model.trigger('change');
                this.render();
            },
            redo:() => {
                this.model.get('gridData')[colId].attributes['alignLeftSelection'] = this.unselectedColor;
                this.model.get('gridData')[colId].attributes['alignCenterSelection'] = this.unselectedColor;
                this.model.get('gridData')[colId].attributes['alignRightSelection'] = this.unselectedColor;

                switch (newValue) {
                    case "left": {
                        this.model.get('gridData')[colId].attributes['alignLeftSelection'] = this.selectedColor;
                        break;
                    }
                    case "center": {
                        this.model.get('gridData')[colId].attributes['alignCenterSelection'] = this.selectedColor;
                        break;
                    }
                    case "right": {
                        this.model.get('gridData')[colId].attributes['alignRightSelection'] = this.selectedColor;
                        break;
                    }
                }
                this.model.get('gridData')[colId].attributes['align'] = newValue;
                // Update without trigger change
                // this.model.trigger('change');
                this.render();
            }
        },textConstants.UNDO_MOVE);
    }

    render() {
        this.$el.empty();
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        //Set Dropdowns
        if (this.model.get('gridData')[this.colId].attributes['format']) {
            var ddValue = this.model.get('gridData')[this.colId].attributes['format'];
            var ddl = $('#format');
            ddl.val(ddValue);
        }

        this.delegateEvents();
        return this;
    }

}

export default MainTextView;
